import { getOperandContent } from './ConditionItem.Rendering';
import CustomDataSourceFields from '../../../../types/report/CustomDataSourceFields';
import IngestionConfig from '../../../../types/ingestion/IngestionConfig';
import Lookup from '../../../../types/functions/Lookup';
import Operand from '../../../../types/functions/Operand/Operand';
import React from 'react';
import ReportFieldDefinition from '../../../../types/report/ReportFieldDefinition';
import ReportVariable from '../../../../types/report/ReportVariable';
import Dictionary from '../../../../types/report/Dictionary';
import UserDefinedFunction from '../../../../types/report/UserDefinedFunction';
import ReportLogicLocation from '../../../../types/functions/Location/ReportLogicLocation';
import Aggregation from '../../../../types/report/Aggregation';
import ReportCase from '../../../../types/report/ReportCase';

const getArgument = (
    operand: Operand,
    operandNumber: number,
    argumentIndexes: number[],
    tooltip: string,
    functions: UserDefinedFunction[],
    globalFunctions: UserDefinedFunction[],
    lookups: Lookup[],
    dictionaries: Dictionary[],
    variables: ReportVariable[],
    dataSources: IngestionConfig[],
    reportFields: ReportFieldDefinition[],
    customDataSourceFields: CustomDataSourceFields,
    selectorNumber: number | null,
    onClick: (operandNumber: number, argumentIndexes: number[], event: React.MouseEvent<HTMLElement>) => void,
    i: number,
    addComma: boolean,
    disabled: boolean,
    reportConfigType: string,
    location?: ReportLogicLocation,
    cases?: ReportCase[],
    aggregations?: Aggregation[]
): JSX.Element => {

    return (
        <span key={i} className='display-flex'>
            {getOperandContent(operand, operandNumber, argumentIndexes, tooltip, functions, globalFunctions, lookups, dictionaries, variables, dataSources, reportFields,
                customDataSourceFields, selectorNumber, (number, argIndexes, event) => { onClick(number, argIndexes, event) }, disabled, reportConfigType, location, cases, aggregations)}
            {addComma && <span className="code draggable-part">,</span>}
        </span>
    );
};

export default getArgument;
